<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>العروض</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              هنا يتم عرض جميع العروض
                                <div class='pull-left' style='padding=0px'>
                                    <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                                      <b>  إضافة جديد </b>
                                    </button>
                                </div>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                              <div class='form-group col-lg-6 col-sm-6'>
                                <span>الفرع:</span>
                                <select @change='GetData($event.target.value)' class="form-control" style="padding: 0px" v-model="branch">
                                  <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                                    {{ item.name }}
                                  </option>
                                </select>
                              </div>
                                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                    <thead>
                                      <tr>

                                          <th style='text-align: center'>الاسم</th>
                                          <th style='text-align: center'>الكاش</th>
                                          <th style='text-align: center'>القسط</th>
                                          <th style='text-align: center'>النوع</th>
                                          <th style='text-align: center'>الحالة</th>
                                          <th style='text-align: center'>الاجراء</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                                          <td align='center'>{{record.offer_name}}</td>
                                          <td align='center'>{{record.price}}</td>
                                          <td align='center'>{{record.installment_price}}</td>
                                          <td v-show='parseInt(record.type) === 0' align='center'>عرض مجانى مع العقد</td>
                                          <td v-show='parseInt(record.type) === 1' align='center'>عرض</td>
                                          <td v-show='parseInt(record.type) === 2' align='center'>عقد</td>
                                          <td v-show='parseInt(record.status) === 0' align='center'>غير نشط</td>
                                          <td v-show='parseInt(record.status) === 1' align='center'>نشط</td>
                                          <td align='center'>
                                              <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                                              <button @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                                              <button @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>تعديل</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- Modal -->
             <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
                 <div class='modal-dialog  modal-lg'>
                     <div class='modal-content'>
                         <div class='modal-header'>
                             <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                             <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
                         </div>
                         <div class='modal-body'>
                           <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                             <ul v-if='validationErrors'>
                                 <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                             </ul>
                           </div>
                           <div class='alert alert-success alert-dismissable' v-if='successShow'>
                              {{success}}
                           </div>
                           <fieldset>
                             <div class='form-group col-lg-3 col-sm-3'  style="padding: 5px;margin:0px 0px 5px 0px">
                               <label>الفرع:</label>
                               <select @change='GetData($event.target.value)' class="form-control" style="padding: 0px" v-model="branch">
                                 <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                                   {{ item.name }}
                                 </option>
                               </select>
                             </div>

                                 <div class='form-group col-lg-4 col-sm-4' style="padding: 5px;margin:0px 0px 5px 0px">
                                     <label>اسم العرض:</label>
                                     <input v-model='record.offer_name' class='form-control' name='offer_name' type='text'>
                                 </div>
                                 <div class='form-group col-lg-3 col-sm-3'  style="padding: 5px;margin:0px 0px 5px 0px">
                                     <label>النوع:</label>
                                     <select style="padding: 1px" class="form-control" v-model="record.type">
                                       <option value='1'>عرض</option>
                                       <option value='0'>عرض مجانى مع العقد</option>
                                       <option value='2'>عقد</option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-2 col-sm-2'  style="padding: 5px;margin:0px 0px 5px 0px">
                                     <label>الحالة:</label>
                                     <select class="form-control" style="padding:0px" v-model="record.status">
                                       <option value='1'>نشط</option>
                                       <option value='0'>غير نشط</option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-8 col-sm-8'  style="padding: 5px;margin:0px 0px 5px 0px">
                                     <label>الوصف فى الايصال:</label>
                                     <input v-model='record.label' class='form-control' name='offer_name' type='text'>
                                 </div>
                                 <div class='form-group col-lg-2 col-sm-2'  style="padding: 5px;margin:0px 0px 5px 0px">
                                     <label>سعر الكاش:</label>
                                     <input :disabled="!this.$per.value.getCompanyInfo" @keypress="isNumber($event)" v-model='record.price' class='form-control' name='price' type='text'>
                                 </div>
                                 <div class='form-group col-lg-2 col-sm-2' style="padding: 5px;margin:0px 0px 5px 0px">
                                     <label>سعر القسط:</label>
                                     <input :disabled="!this.$per.value.getCompanyInfo" @keypress="isNumber($event)" v-model='record.installment_price' class='form-control' name='installment_price' type='text'>
                                 </div>
                                 <div class='form-group col-lg-3 col-sm-3' style="padding: 5px;margin:0px 0px 5px 0px">
                                     <label>عمولة تلى للكاش:</label>
                                     <input @keypress="isNumber($event)" v-model='record.cash_commission' class='form-control' name='offer_name' type='text'>
                                 </div>
                                 <div class='form-group col-lg-3 col-sm-3' style="padding: 5px;margin:0px 0px 5px 0px">
                                     <label>عمولة تلى للقسط:</label>
                                     <input @keypress="isNumber($event)" v-model='record.premium_commission' class='form-control' name='offer_name' type='text'>
                                 </div>
                                 <div class='form-group col-lg-3 col-sm-3' style="padding: 5px;margin:0px 0px 5px 0px">
                                   <label>عمولة فنى منفذ:</label>
                                   <input @keypress="isNumber($event)" v-model='record.tec_exe_commission' class='form-control' name='offer_name' type='text'>
                                 </div>
                                 <div class='form-group col-lg-3 col-sm-3' style="padding: 5px;margin:0px 0px 5px 0px">
                                     <label>ع فنى غير منفذ:</label>
                                     <input @keypress="isNumber($event)" v-model='record.tec_not_exe_commission' class='form-control' name='offer_name' type='text'>
                                 </div>
                                 <div class='form-group col-lg-4 col-sm-4' style="padding: 5px;margin:0px 0px 5px 0px">
                                   <label>ع فنى منفذ + تفويض:</label>
                                   <input @keypress="isNumber($event)" v-model='record.tec_del_exe_commission' class='form-control' name='offer_name' type='text'>
                                 </div>
                                 <div class='form-group col-lg-4 col-sm-4' style="padding: 5px;margin:0px 0px 5px 0px">
                                     <label>ع فنى غير منفذ + تفويض:</label>
                                     <input @keypress="isNumber($event)" v-model='record.tec_del_not_exe_commission' class='form-control' name='offer_name' type='text'>
                                 </div>
                                 <div class='form-group col-lg-4 col-sm-4' style="padding: 28px 1px 1px 1px;">
                                   <div class="form-group" style='text-align: center'>
                                     <button @click='saveOfferData' type='button' class='btn btn-primary btn-block'>حفظ</button>
                                     <vue-element-loading size='32' :active='isLoadingSaveOffer' spinner='bar-fade-scale' color='#A4A4A4'/>
                                   </div>
                                 </div>
                               </fieldset>
                               <fieldset v-show="record.id > 0" >
                                 <div class='form-group col-lg-4 col-sm-4' style="padding: 1px">
                                     <div class="form-group">
                                       <span>الصنف:</span>
                                       <select  @change='GetPrice($event)' class="form-control" style="padding: 1px" v-model="item">
                                         <option v-for="item in items" v-bind:key="item.id" v-bind:value="item.id">
                                           {{ item.item }}
                                         </option>
                                       </select>
                                     </div>
                                 </div>
                                     <div class='form-group col-lg-2 col-sm-2' style="padding: 1px">
                                         <span>العدد:</span>
                                         <input @keypress="isNumber($event)" v-model='item_pieces' class='form-control' name='price' type='text'>
                                     </div>
                                     <div class='form-group col-lg-3 col-sm-3' style="padding: 22px 1px 1px 1px;">
                                       <button @click='saveOfferItem' type='button' class='btn btn-outline btn-success btn-block'>إضافة</button>
                                         <vue-element-loading size='32' :active='isLoadingSaveOffer' spinner='bar-fade-scale' color='#A4A4A4'/>
                                     </div>
                                     <div class='form-group col-lg-3 col-sm-3' style="padding: 22px 1px 1px 1px;">
                                       <button @click='newOfferItem' type='button' class='btn btn-outline btn-info btn-block'>جديد</button>
                                     </div>
                                   </fieldset>
                               <div class='form-group'>
                                 <table width='100%' class='table  table-bordered '>
                                   <thead>
                                     <tr>
                                       <th style='vertical-align: middle;padding:2px;text-align: center'>الصنف</th>
                                       <th style='vertical-align: middle;padding:2px;text-align: center'>الكمية</th>
                                       <th style='vertical-align: middle;padding:2px;text-align: center'>الاجراء</th>
                                     </tr>
                                   </thead>
                                   <tbody>
                                     <tr class='odd gradeX' v-for='(record) in offresItemsRecords' :key='record.id'>
                                       <td align='center' style="vertical-align: middle;padding:5px">{{record.item}}</td>
                                       <td align='center' style="vertical-align: middle;padding:5px">{{record.item_pieces}}</td>
                                       <td align='center'>
                                         <vue-element-loading size='32' :active='isLoadingItemDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                                         <button @click='deleteItemData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                                       </td>
                                     </tr>
                                   </tbody>
                                 </table>
                               </div>

                           </div>
                           <div class='modal-footer'>
                               <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                           </div>
                     </div>
                     <!-- /.modal-content -->
                 </div>
                 <!-- /.modal-dialog -->
             </div>
             <!-- /.modal -->
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'offers',
  data () {
    return {
      validationErrors: '',
      records: {},
      offresItemsRecords: {},
      record: {},
      items: {},
      item: '',
      item_Price: '',
      item_pieces: 1,
      total_item_Price: '',
      offer_Price: '',
      branches: {},
      branch: 0,
      errorShow: false,
      successShow: false,
      isLoadingSaveOffer: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      isLoadingItemDelete: false,
      title: ''
    }
  },
  mounted: function () {
    this.$watch('item_pieces', function () {
      this.total_item_Price = parseInt(this.item_pieces || 0) * parseInt(this.item_Price || 0)
    })
    this.$watch('item_Price', function () {
      this.total_item_Price = parseInt(this.item_pieces || 0) * parseInt(this.item_Price || 0)
    })
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branch = localStorage.getItem('BrancheID')
    this.GetData()
    this.items = JSON.parse(localStorage.getItem('Items'))
  },
  methods: {
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    isLocked: function (evt) {
      evt.preventDefault()
    },
    GetData () {
      // this.isLoadingData = true
      axios.post(this.$apiURL + 'getOffers', {
        token: localStorage.getItem('token'),
        branch_id: this.branch
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    GetPrice (event) {
      let i = this.items.findIndex(x => x.id === parseInt(event.target.value))
      if (i > -1) {
        this.item_Price = this.items[i].price
      } else {
        this.item_Price = 0
      }
    },
    showForm (recID) {
      this.offer_Price = ''
      this.item_Price = ''
      this.item = ''
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {'id': 0, 'offer_name': '', 'price': 0, 'status': 1, 'branch_id': '', 'label': '', 'type': 1, 'installment_price': 0, 'cash_commission': 0, 'premium_commission': 0, 'tec_exe_commission': 0, 'tec_not_exe_commission': 0, 'tec_del_exe_commission': 0, 'tec_del_not_exe_commission': 0}
        this.offresItemsRecords = {}
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = recID
        this.offresItemsRecords = recID.offer_items
      }
    },
    saveOfferData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveOffers', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        offer_name: this.record.offer_name,
        price: this.record.price,
        installment_price: this.record.installment_price,
        status: this.record.status,
        label: this.record.label,
        type: this.record.type,
        cash_commission: this.record.cash_commission,
        premium_commission: this.record.premium_commission,
        tec_exe_commission: this.record.tec_exe_commission,
        tec_not_exe_commission: this.record.tec_not_exe_commission,
        tec_del_exe_commission: this.record.tec_del_exe_commission,
        tec_del_not_exe_commission: this.record.tec_del_not_exe_commission,
        branch_id: this.branch
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data)
            this.offresItemsRecords = res.data.offer_items
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
          this.record = res.data
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    newOfferItem () {
      this.offer_Price = ''
      this.item_Price = ''
      this.item = ''
      this.item_pieces = 1
    },
    saveOfferItem () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveOffer_items', {
        token: localStorage.getItem('token'),
        id: 0,
        offer_id: this.record.id,
        new_price: this.offer_Price,
        old_price: this.total_item_Price,
        discount: this.total_item_Price - this.offer_Price,
        label: this.record.label,
        item_pieces: this.item_pieces,
        item_id: this.item
      })
        .then(res => {
          this.isLoadingSave = false
          // this.offresItemsRecords.push(res.data)
          let i = this.records.map(record => record.id).indexOf(this.record.id)
          this.records[i].offer_items.push(res.data)
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteItemData (recID) {
      this.isLoadingItemDelete = true
      axios.post(this.$apiURL + 'deleteOffer_items', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.offresItemsRecords.map(record => record.id).indexOf(recID)
          this.offresItemsRecords.splice(i, 1)
          this.isLoadingItemDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingItemDelete = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteOffers', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Offers.vue